import { Drawer } from "@mantine/core"
import { cn } from "@/lib/utils"
import { store } from "@/stores/stores"
import { useSnapshot } from "valtio"
import GenericAction from "./Generic.action"
import { NodeDefinition } from "@/gen"

export interface BaseDrawerProps {
  deleteGhostNode: () => void
  replaceGhostNode: (actionType: string) => void
  // syncForm: () => void
  nodeId?: string
  getSafeLabel: (name: string, nodeId?: string) => string
}

function BaseDrawer(props: BaseDrawerProps) {
  const snap = useSnapshot(store)

  // const withOverlay =
  //   !!snap.scenario.selectedNode &&
  //   (snap.scenario.selectedNode.node_type !== ActionTypeId.ADD_ACTION || snap.scenario.selectedNode.node?.id === "ghost")
  const withOverlay = snap.scenario.editing.selectedNode?.node?.id === "ghost"
  const opened = !!snap.scenario.editing.selectedNode
  const action: NodeDefinition | null = opened
    ? store.scenario.nodeDefinitions.record[snap.scenario.editing.selectedNode!.node_type]
    : null

  // useOnSelectionChange({
  //   onChange: ({ nodes, edges }) => {

  //   }
  // });

  // const drawerProps = {
  //   opened,
  //   onClose: () => {
  //     store.scenario.actions.setSelectedNode(null)
  //   },
  //   position: "right",
  //   offset: 16,
  //   radius: "lg",
  //   overlayProps: {
  //     className: "bg-[rgba(34,39,45,0.24)]",
  //   },
  //   withOverlay,
  //   style:
  //     withOverlay
  //       ? {}
  //       : {
  //           "--drawer-height": "calc(100% - 110px)",
  //         },
  //   className: cn("[&_.mantine-Drawer-inner]:absolute", !withOverlay && `[&_.mantine-Drawer-content]:mt-auto`),
  //   withinPortal: false,
  // }

  const onClose = () => {
    // if (store.scenario.selectedNode?.node?.type === "ghost" || !store.scenario.selectedNode) {
    props.deleteGhostNode()
    // }

    store.scenario.actions.setSelectedNode(null)
  }

  return (
    <>
      <Drawer
        opened={opened}
        onClose={onClose}
        onExitTransitionEnd={() => {
          onClose()
        }}
        position="right"
        offset={8}
        radius="lg"
        overlayProps={{
          // className: "bg-[rgba(34,39,45,0.24)]",
          // className: "bg-[rgba(34,39,45,0.08)]",
          className: "bg-transparent",
        }}
        withCloseButton={false}
        withOverlay={withOverlay}
        // style={
        //   withOverlay
        //     ? {}
        //     : {
        //         // "--drawer-height": "calc(100% - var(--header-height) - 100px)",
        //         "--drawer-height": "calc(100% - var(--header-height) - 30px)",
        //       }
        // }
        style={{
          // "--drawer-height": "calc(100% - var(--header-height) - 100px)",
          "--drawer-height": "calc(100% - 90px)",
        }}
        size="sm"
        className={cn(
          `
            !max-w-[100px]
            [&_.mantine-Drawer-body]:p-0 [&_.mantine-Drawer-body]:h-full

            [&_.mantine-Drawer-content]:mt-auto [&_.mantine-Drawer-content]:overflow-visible

            [&_.mantine-Drawer-inner]:absolute [&_.mantine-Drawer-inner]:z-200
          `,
          snap.scenario.editing.draggingNode && "[&_.mantine-Drawer-content]:!opacity-0",
          // !withOverlay && `[&_.mantine-Drawer-content]:mt-auto`,
        )}
        // withinPortal={false}
      >
        {action &&
          ((action as any).drawer ? (
            <action.drawer {...props} onClose={onClose} />
          ) : (
            <GenericAction
              {...props}
              action={store.scenario.editing.selectedNode?.node?.data}
              // syncForm={props.syncForm}
              nodeId={store.scenario.editing.selectedNode?.node?.id!}
              onClose={onClose}
              key={"key_" + store.scenario.editing.selectedNode?.node?.id}
            />
          ))}
          <br />
          <br />
      </Drawer>
    </>
  )
}

export default BaseDrawer
